import React from 'react';
import { useNavigate } from 'react-router-dom';

import { resetSavedLocalData } from '@app/components/Pages/Booking/Booking';

interface PetRequiresAttentionProps {
	title: string;
	onClick?: () => void;
}

const PetRequiresAttention: React.FC<PetRequiresAttentionProps> = ({ title, onClick }) => {
	const navigate: any = useNavigate();

	const defaultDone = () => {
		resetSavedLocalData(navigate, '/');
	};

	return (
		<div className="online-booking-step-container no-one-can-help">
			<h1>{title}</h1>

			<div className="no-one-can-help__text">
				<p>We want to make sure every pet gets the best care possible and we need a little extra information to complete your booking.</p>
				<p>
					A member of Lap of Love will contact you from
					{' '}
					<a href="tel:8559335683" className="inline-block inline-link">
						(855) 933-5683.
					</a>
					<br />
					Thank you!
				</p>
			</div>

			<button onClick={onClick || defaultDone} className="btn btn-primary link">
				Done
			</button>
		</div>
	);
};

export default PetRequiresAttention;
